/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineProductService() {
        let productService = {};
        productService.getProducts = function (request){
            return axios.post("/api/ProductService/GetProducts", request);
        };
        productService.getProduct = function (productId){
            return axios.get("/api/ProductService/GetProduct?productId=" + productId);
        };
        return productService;
    }
    //define globally if it doesn't already exist
    if (typeof (productService) === "undefined") {
        window.productService = defineProductService();
    } else {
        console.log("productService already defined.");
    }
})(window);